// extracted by css-extract-rspack-plugin
export default {"link":"hIBCm","selected":"wKBcW","icon":"ZUqyn","round_icon":"QpO_d","roundIcon":"QpO_d"};